import type { FC } from 'react'
import { useState } from 'react'
import cn from 'classnames'
import { Input } from 'components/ui'
import SvgSearch from 'components/icons/Search'
import { useNotification } from 'hooks/use-notification'
import type { SearchProps } from '.'
import s from './search.module.css'

const Search: FC<SearchProps> = ({ className, onSubmit }) => {
  const { notify } = useNotification()
  const [search, setSearch] = useState('')

  function onChange(e: any) {
    setSearch(e.target.value)
  }

  function handleSubmit(event: any) {
    event.preventDefault()
    if(search.length === 0) {
      setSearch('');
    } else if (search.length < 3) {
      notify({ title: 'Seja mais específico', type: 'danger' })
      return
    }
    onSubmit(search)
  }

  return (
    <form onSubmit={handleSubmit} className={cn(s.root, className)}>
      <div className={s.searchContainer}>
        <span className={s.searchIcon}>
          <SvgSearch />
        </span>
        <Input
          type="search"
          name="search"
          placeholder="Pesquisar..."
          pure
          onChange={onChange}
          inputClassName={s.searchInput}
        />
      </div>
    </form>
  )
}

export default Search
